
import AnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";

export default class ExpandAnimateSymbolBehaviour extends AnimateSymbolBehaviour {

    public behaviourName: string = "ExpandAnimate";

    /**
     * Same as AnimateBehaviour except for expanding
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAnimation="win"] {string}
     */
    constructor(symbol: SymbolComponent, defaultAnimation: string = "expand") {
        super(symbol, defaultAnimation);
    }

    public expand(x: number = 0, y: number = 0): Contract<void> {
        let suffix;

        if (y < 0) {
            suffix = "_expand_up";
        } else if (y > 0) {
            suffix = "_expand_down";
        } else {
            suffix = "_expand";
        }
        return this.animate([suffix, "_expand"], ["expand"]);
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }
}
